import axios from 'axios'

export default {
    index (entityId) {
        return axios.get(`/api/entities/${entityId}/customizations`)
    },
    store (entityId, customization) {

        let data = new FormData()
        data.append('primary_color', customization.primary_color)
        data.append('dark_theme', customization.dark_theme ? 1 : 0)
        data.append('infos', customization.infos)

        if (customization.image) {
            data.append('image', customization.image)
        }

        return axios.post(`/api/entities/${entityId}/customizations`, data, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
    }
}